// utils/hapticFeedback.ts
export const HapticFeedback = {
    // Легкий тап - для обычных кнопок и переключений
    light: () => {
        try {
            if (window.Telegram?.WebApp?.HapticFeedback?.impactOccurred) {
                window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
            }
        } catch (error) {
            console.warn('Haptic feedback not available:', error);
        }
    },

    // Средний тап - для важных действий
    medium: () => {
        try {
            if (window.Telegram?.WebApp?.HapticFeedback?.impactOccurred) {
                window.Telegram.WebApp.HapticFeedback.impactOccurred('medium');
            }
        } catch (error) {
            console.warn('Haptic feedback not available:', error);
        }
    },

    // Сильный тап - для критически важных действий
    heavy: () => {
        try {
            if (window.Telegram?.WebApp?.HapticFeedback?.impactOccurred) {
                window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy');
            }
        } catch (error) {
            console.warn('Haptic feedback not available:', error);
        }
    },

    // Успешное действие
    success: () => {
        try {
            if (window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred) {
                window.Telegram.WebApp.HapticFeedback.notificationOccurred('success');
            }
        } catch (error) {
            console.warn('Haptic feedback not available:', error);
        }
    },

    // Ошибка или предупреждение
    error: () => {
        try {
            if (window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred) {
                window.Telegram.WebApp.HapticFeedback.notificationOccurred('error');
            }
        } catch (error) {
            console.warn('Haptic feedback not available:', error);
        }
    },

    // Предупреждение
    warning: () => {
        try {
            if (window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred) {
                window.Telegram.WebApp.HapticFeedback.notificationOccurred('warning');
            }
        } catch (error) {
            console.warn('Haptic feedback not available:', error);
        }
    },

    // Изменение выбора (для переключателей, чипов)
    selectionChanged: () => {
        try {
            if (window.Telegram?.WebApp?.HapticFeedback?.selectionChanged) {
                window.Telegram.WebApp.HapticFeedback.selectionChanged();
            }
        } catch (error) {
            console.warn('Haptic feedback not available:', error);
        }
    }
};